export default "__VITE_ASSET__DR517pU8__"